/**
 * Update the ':root' styles with the Theme options, so the same 
 * theme settings can be used inside all CSS and SCSS declarations.
 * 
 * @created: 28-Sep-2021 - mario.Zito@treme.io
 */
/*
  For example the Theme domain 'colors': 

    colors = {
      // base colors
      primary: "#f4511e",//"#ef4801", //#C62828", // #e04b00, #f5715b,
      tertiary: '#2f2f4f',
      secondary: '#28e997',
      white: '#fff',
      black: '#000',
    }

  will be inserted in the :root style sheet as:

    :root {
      --colors-primary: #f4511e;
      --colors-tertiary: #2f2f4f;
      --colors-secondary: #28e997;
      --colors-white: #fff;
      --colors-black: #000;
    }
*/

export function updateRootStyleSheet(theme) {
  setRootColors(theme.colors);
}

function setRootColors(colors) {
  Object.keys(colors || {}).forEach(prop => {
    const name = '--colors-'+prop;
    const value = colors[prop]+'';
    document.documentElement.style.setProperty(name, value);
  })
}
